import { VariableType } from 'json-to-graphql-query';
export const CardInputVariables = { profileId: 'Int!', card: 'CardInput!' };
export const CardInputArgs = { profileId: new VariableType('profileId'), card: new VariableType('card') };
export const CardEditVariables = { id: 'Int!', card: 'CardInput!' };
export const CardEditArgs = { id: new VariableType('id'), card: new VariableType('card') };
//# sourceMappingURL=card.js.map